import React from 'react';
import { connect } from 'react-redux';

import SectionTitle from '../components/SectionTitle';
import GoogleMap from '../components/GoogleMap';
import ParseHTML from '../components/ParseHTML';

if (process.env.BROWSER) {
    require('flexboxgrid');
}

const Contact = React.createClass({
    propTypes: {
        title: React.PropTypes.string,
        section_title: React.PropTypes.string,
        members: React.PropTypes.array,
        street: React.PropTypes.string,
        number: React.PropTypes.string,
        plz: React.PropTypes.string,
        ort: React.PropTypes.string,
        tel: React.PropTypes.string,
        fax: React.PropTypes.string,
        email: React.PropTypes.string
    },
    render: function() {
        return (
            <div id="contact">
                <SectionTitle>{this.props.section_title}</SectionTitle>
                <GoogleMap>
                    <p>
                        <b><ParseHTML>{this.props.title}</ParseHTML></b> <br />
                        <span>{this.props.street} {this.props.number}</span><br />
                        <span>{this.props.plz} {this.props.ort}</span><br />
                    </p>
                    <p>
                        <span>Tel. {this.props.tel}</span><br />
                        <span>Fax {this.props.fax}</span><br />
                    </p>
                    <p>
                        {this.props.email ? <span>E-Mail: <a href={`mailto:${this.props.email}`}>{this.props.email} </a> </span>: null}
                    </p>
                </GoogleMap>
            </div>
        );
    }
});

const mapStateToProps = (state) => {
    return {
        section_title: state.contact.title,
        title: state.company.title,
        street: state.company.address.street,
        number: state.company.address.number,
        plz: state.company.address.plz,
        ort: state.company.address.ort,
        tel: state.company.address.tel,
        fax: state.company.address.fax,
        email: state.company.address.email
    };
};

export default connect(mapStateToProps)(Contact);



// WEBPACK FOOTER //
// ./src/js/containers/Contact.js